import { exhaustiveGuard } from "@mcwd/typescript-type-guards";
import { UserGatingLevelCookieWrapper } from "../../../marketo/form-logic/gating/user-gating-level-cookie-wrapper.js";
import { ComputedValueGetter } from "../../../utils/ComputedValueGetter.js";

export type MarketoKnownUserStatus = "Unknown" | "Full" | "Partial";

export function getMarketoKnownUserStatus (): MarketoKnownUserStatus
{
  const result = UserGatingLevelCookieWrapper.GatingLevel;

  if (result === "NeedsForm")
  {
    return "Unknown";
  }
  else if (result === "FullGate")
  {
    return "Full";
  }
  else if (result === "PartialGate")
  {
    return "Partial";
  }
  else
  {
    exhaustiveGuard(result);
  }
}

export const InitialMarketoKnownUserStatus = new ComputedValueGetter({
  isLazy: true,
  computeFn: () =>
  {
    return getMarketoKnownUserStatus();
  }
});

